import { blockConverters } from "..";
import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";
import type { ElementType } from "@/react/types/Element";

// Converts a form element to a BuilderUI block
export const elementToBlock = (
  element: ElementType,
  fieldIndex?: number,
): BaseBlock => {
  switch (element.type) {
    case "field": {
      switch (element.attributes.field_type) {
        case "contact_name":
          return blockConverters.FormContactNameBlock.elementToBlock(
            element,
            fieldIndex ?? 0,
          );
        case "contact_email":
          return blockConverters.FormContactEmailBlock.elementToBlock(
            element,
            fieldIndex ?? 0,
          );
        default:
          throw new Error(`Unknown field type`);
      }
    }

    case "text": {
      const textType = element.attributes.text_type;
      if (textType === "title" || textType === "subtitle") {
        return blockConverters.FormHeadingBlock.elementToBlock(element);
      }
      return blockConverters.FormParagraphBlock.elementToBlock(element);
    }

    case "button":
      return blockConverters.FormButtonBlock.elementToBlock(element);

    case "layout":
      return blockConverters.FormStackBlock.elementToBlock(element);

    default:
      throw new Error("Unknown element type");
  }
};
